<template>
  <div>
    <SiteHeader />
    <div class="page flex-col">
      <img
        class="image_1"
        referrerpolicy="no-referrer"
        src="./assets/img/SketchPnge6526ecb2fcab0802b546f04824fe8f83db80e06fef6b8cf3b08d187c494f182.png"
      />
      <div class="section_1 flex-col">
        <div class="block_3 flex-col">
        <div class="group_3 flex-row">
          <div class="text-group_1 flex-col">
            <span class="text_13">机构与历史</span>
            <span class="text_14">
              （文案占位非正式内容）中国社会科学院新闻与传播研究所（原名『中国社会科学院新闻研究所』）成立于中国改革开放扬帆起航的&nbsp;1978&nbsp;年。
            </span>
          </div>
        </div>
        <div class="text-wrapper_2">
          <span class="text_15">
            <router-link to="/lanhu_shouye" style="color: inherit; text-decoration: none;">首页</router-link>
            &nbsp;&gt;&nbsp;
            <router-link to="/lanhu_jigouyulishi" style="color: inherit; text-decoration: none;">机构与历史</router-link>
            &nbsp;&gt;&nbsp;
          </span>
          <span class="text_16">{{ currentMenuLabel }}</span>
        </div>
        <div class="group_4 flex-col"></div>
        <div class="group_5 flex-row justify-between">
          <SidebarAccordion
            :sections="sidebarSections"
            active-section-id="org-history"
            :active-item-id="activeItemId"
            :active-sub-item-id="activeSubItemId"
          />
          <div class="group_7 flex-col">
            <div class="text-wrapper_4 flex-col"><span class="text_19">{{ currentMenuLabel }}</span></div>
            <span class="text_20">
              中国社会科学院新闻与传播研究所（原名『中国社会科学院新闻研究所』）成立于中国改革开放扬帆起航的&nbsp;1978&nbsp;年。它的创建，是党和国家领导人在拨乱反正进程中重启新闻学科建设的重要举措，承载着几代新闻学人继承优良传统，总结经验训，探索新闻规律，创新学科理论和专业知识的抱负与理想。
            </span>
          </div>
        </div>
        <img
          class="image_4"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPngf2db7c42f34aa1f79b8c9e6e04312472a62b4addcd6eb63d18c15a884d991545.png"
        />
        <SecondaryBottom
          variant="history"
          :config="bottomConfig"
        />
      </div>
    </div>
    <SiteFooter
      :notch-width="704"
      notch-left="calc((100vw - 1300px) / 2 + 445px)"
    />
  </div>
</div>
</template>
<script>
import SiteHeader from '@/components/SiteHeader.vue';
import SiteFooter from '@/components/SiteFooter.vue';
import SidebarAccordion from '@/components/SidebarAccordion.vue';
import SecondaryBottom from '@/components/SecondaryBottom.vue';
import { createSidebarSections, LEADERSHIP_CHAPTERS } from '@/config/secondarySidebar';

import highlightQuoteIcon from './assets/img/SketchPng6bbcd424ff3f6d3d590012e7289d478b97d5a2f10c28bd454d1364ed6ae811bb.png';
import galleryMainImage from './assets/img/SketchPng9c9b995fbf6bdc41ccc12fcfd4c6032a48a2b0b79824968ef62e0c923c05b0f6.png';
import sidePanelImage from './assets/img/SketchPng17d8a996ffedbcf62f923651158a7b0e3e6a1369ff2341ae3775e2a3f0b15678.png';
import galleryThumb1 from './assets/img/history_gallery_1.png';
import galleryThumb2 from './assets/img/history_gallery_2.png';
import galleryThumb3 from './assets/img/history_gallery_3.png';
import galleryThumb4 from './assets/img/history_gallery_4.png';

export default {
  components: {
    SiteHeader,
    SiteFooter,
    SidebarAccordion,
    SecondaryBottom
  },
  data() {
    const galleryItems = [galleryThumb1, galleryThumb2, galleryThumb3, galleryThumb4];

    return {
      activeItemId: 'leadership-care',
      activeSubItemId: '',
      sidebarSections: [],
      bottomConfig: {
        title: '珍贵历史图片资料',
        highlightText:
          '&nbsp;1978&nbsp;年&nbsp;6&nbsp;月&nbsp;15&nbsp;日，邓小平、李先念等党和国家领导人批复同意中国社会科学院增设新闻研究所的文件影印件',
        highlightIcon: highlightQuoteIcon,
        gallery: {
          mainImage: galleryMainImage,
          items: galleryItems
        },
        sideParagraph:
          '&nbsp;1980&nbsp;年&nbsp;2&nbsp;月&nbsp;6&nbsp;日，北京新闻学会（挂靠在新闻研究所，1984&nbsp;年改名为首都新闻学会）<br />成立大会在中国革命历史博物馆礼堂召开。胡乔木到会讲话，胡愈之、张友渔等出席会议，安岗主持会议',
        sideImage: sidePanelImage
      },
      constants: {}
    };
  },
  computed: {
    currentMenuLabel() {
      if (this.activeItemId === 'evolution-history') {
        return '建制沿革';
      }
      return '领导关怀';
    }
  },
  created() {
    this.syncSidebarStateByRoute();
  },
  watch: {
    $route() {
      this.syncSidebarStateByRoute();
    }
  },
  methods: {
    syncSidebarStateByRoute() {
      const item = this.$route && this.$route.query ? this.$route.query.item : '';
      const subitem = this.$route && this.$route.query ? this.$route.query.subitem : '';
      const nextActiveItemId = item === 'evolution-history' ? 'evolution-history' : 'leadership-care';
      const validSubItems = {
        'leadership-care': LEADERSHIP_CHAPTERS.map((chapter) => chapter.id),
        'evolution-history': ['name-change', 'office-location-change', 'organization-setup']
      };
      const nextActiveSubItemId =
        validSubItems[nextActiveItemId] && validSubItems[nextActiveItemId].includes(subitem) ? subitem : '';

      this.activeItemId = nextActiveItemId;
      this.activeSubItemId = nextActiveSubItemId;
      this.sidebarSections = createSidebarSections({
        activeSectionId: 'org-history',
        activeItemId: nextActiveItemId,
        activeSubItemId: nextActiveSubItemId,
        primaryItemIds: ['discipline-build']
      });
    }
  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />
